import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { clearError } from "@mobile-dev/platform/common/redux/actions/CommonAction";
import { injectIntl } from 'react-intl';
import { useDispatch } from "react-redux";

function CompletedDetailsDialoge({ intl, open= true, id, loadId, onClose, shareReceiptHeaderText }) {

    const [show, setShow] = useState(open);
    const { formatMessage } = intl;
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(clearError());
    }, []);


    const handleClose = () => {
        setShow(false);
        onClose();
    }

    return (
        <React.Fragment>
            <Modal
                className="fade contest_input_modal receipt-modal"
                show={show}
                onHide={handleClose}
                backdrop='static'
                keyboard={false}
                
            >
                    {/* <Modal.Dialog className="modal-dialog-centered modal-our"> */}
                    <Modal.Header closeButton>
                        <h4 class="modal-title">{shareReceiptHeaderText}</h4>
                    </Modal.Header>
                        <Modal.Body className="recipt-modal">

                            <div className="row">
                                <div class="col-md-12">
                                    {formatMessage({id: "app.receipt_dialoge"})}
                                </div>

                            </div>
                        </Modal.Body>
                        <Modal.Footer className="border-0 justify-content-center pb-2">
                        <Button variant="primary" onClick={handleClose}>{formatMessage({ id: "app.close" })}</Button>
                            {/* <button type="button" className="btn btn-outline-dark" style={{ minWidth: '100px' }} onClick={handleClose}>
                            {formatMessage({ id: "app.close" })}</button> */}
                        </Modal.Footer>
                    {/* </Modal.Dialog> */}

            </Modal>

        </React.Fragment>
    )
}

export default injectIntl(CompletedDetailsDialoge);